var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "rb-panel",
    {
      staticClass: "rb-facets-panel",
      attrs: {
        visible: _vm.panelIsOpen,
        "open-direction": "left",
        "disabled-close-button": _vm.disabledCloseButton,
      },
      on: {
        closed: function ($event) {
          return _vm.$emit("closed")
        },
      },
      scopedSlots: _vm._u([
        {
          key: "close-icon",
          fn: function () {
            return [
              _c("rb-lazy-icon", {
                attrs: { icon: "close-bold", text: "close" },
              }),
            ]
          },
          proxy: true,
        },
        {
          key: "title",
          fn: function () {
            return [
              _vm._v("\n    " + _vm._s(_vm.$t("plp.filters_title")) + "\n  "),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _vm._v(" "),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "rb-facets-panel__content" },
        [
          _vm.appliedFacets.length > 0
            ? _c("rb-selected-facets", {
                attrs: {
                  facets: _vm.facets,
                  "applied-facets": _vm.appliedFacets,
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm._l(_vm.facetsElements, function (facet) {
            return [
              facet.values.length > 0
                ? [
                    _vm.isToggleBlock(facet.key) && facet.showFacet
                      ? [
                          _c("rb-toggle-block", {
                            key: facet.key,
                            attrs: { facet: facet },
                          }),
                        ]
                      : [
                          facet.showFacet
                            ? _c(
                                "rb-accordion",
                                {
                                  key: facet.key,
                                  attrs: { open: facet.open },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "icon",
                                        fn: function () {
                                          return [
                                            _c("rb-lazy-icon", {
                                              attrs: { icon: "caret-big-down" },
                                            }),
                                          ]
                                        },
                                        proxy: true,
                                      },
                                      {
                                        key: "title",
                                        fn: function () {
                                          return [
                                            _vm._v(
                                              "\n              " +
                                                _vm._s(
                                                  _vm.labelToShow(facet.label)
                                                ) +
                                                "\n            "
                                            ),
                                          ]
                                        },
                                        proxy: true,
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                },
                                [
                                  _vm._v(" "),
                                  _vm._v(" "),
                                  _c("rb-facet-values", {
                                    attrs: {
                                      facet: facet,
                                      "min-price-range": _vm.minPriceRange,
                                      "max-price-range": _vm.maxPriceRange,
                                      "reset-facet-price": _vm.resetFacetPrice,
                                      "applied-facets": _vm.appliedFacets,
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                  ]
                : _vm._e(),
            ]
          }),
        ],
        2
      ),
      _vm._v(" "),
      _c("div", { staticClass: "rb-facets-panel__footer" }, [
        _c(
          "button",
          {
            staticClass: "rb-btn rb-btn--white",
            on: {
              click: function ($event) {
                return _vm.$emit("reset")
              },
            },
          },
          [
            _vm._v(
              "\n      " + _vm._s(_vm.$t("plp.filters.clear_all")) + "\n    "
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "rb-btn rb-btn--black",
            attrs: { disabled: _vm.disabledCloseButton },
            on: {
              click: function ($event) {
                return _vm.$emit("closed")
              },
            },
          },
          [
            _vm._v(
              "\n      " +
                _vm._s(_vm.$t("plp.filters.see_result")) +
                " (" +
                _vm._s(_vm.totalProducts) +
                ")\n    "
            ),
          ]
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }